import IsIos from '@/mixins/is-ios.js'
import formValidator from '@/mixins/form-validator.js'
import PrefixesMixin from '@/mixins/prefixes.js'
import toastStore from '@/stores/toast-store.js'
import logo from '@/assets/images/collectomate-logo.png'
import acceptance from '@/validators/acceptance.js'
import { required } from 'vuelidate/lib/validators'
import axios from 'axios'

import TermsOfUseModal from '@/vcs/_shared/modals/terms-of-use/cmp.vue'
import MbankTermsOfUseModal from '@/vcs/_shared/modals/mbank-terms-of-use/cmp.vue'
import FrontexTermsOfUseModal from '@/vcs/_shared/modals/frontex-terms-of-use/cmp.vue'

export default {
  name: 'Register',
  mixins: [IsIos, formValidator, PrefixesMixin],
  data: function () {
    return {
      errors: {},
      submitted: false,
      logo: logo,

      user: {
        email: '',
        password: '',
        phonePrefix: '',
        phone: '',
        termsAgreement: false,
        mbankPasswordAgreement: false,
      },

      blocker: false,
      // registerInfo: false,
      validatedItemKey: 'user',
      passwordInputType: 'password',
    }
  },
  created() {
    this.setPhonePrefix()
  },
  methods: {
    signUpWithConfirmations(event) {
      if (this.$isFrontex) {
        this.submitted = true
        this.validateForm()

        if (Object.keys(this.errors).length > 0) {
          toastStore.commit('error', {
            message: this.$t('messages.validationErrorFillFields'),
          })
        } else {
          this.$store.commit('modal/open', {
            cmp: FrontexTermsOfUseModal,
            animation: 'slide-down-menu',
            callback: this.signUp,
          })
        }
      } else {
        this.signUp()
      }
      event.preventDefault()
    },
    signUp() {
      this.submitted = true
      this.validateForm()

      if (Object.keys(this.errors).length > 0) {
        toastStore.commit('error', {
          message: this.$t('messages.validationErrorFillFields'),
        })
      } else {
        this.blocker = true
        axios({
          method: 'post',
          url: 'auth/sign_up',
          data: {
            user: {
              email: this.user.email,
              password: this.user.password,
              phonePrefix: this.user.phonePrefix,
              phone: this.user.phone,
              pwaContext: this.$slug,
            },
          },
        })
          .then(() => {
            this.blocker = false
            alert(
              'Wysłaliśmy na twój adres email wiadomość aktywacyjną. Potwierdź konto klikając na link znajdujący się w wiadomosci.',
            )
            this.$router.push('/')
          })
          .catch(error => {
            let errorMessage
            this.blocker = false
            if (error.response.status == 422) {
              this.errors = { ...error.response.data.errors }
              errorMessage = this.$t('messages.formError')
            } else {
              errorMessage = this.$t('messages.error')
            }
            toastStore.commit('error', { message: errorMessage })
            console.error('error signUp', error.response)
          })
      }
    },
    showTermsOfUse() {
      if (this.$isMbank) {
        this.$store.commit('modal/open', {
          cmp: MbankTermsOfUseModal,
          animation: 'slide-down-menu',
        })
      } else {
        this.$store.commit('modal/open', {
          cmp: TermsOfUseModal,
          animation: 'slide-down-menu',
        })
      }
    },
    setPhonePrefix() {
      const language = window.navigator.userLanguage || window.navigator.language
      const normalizedLanguage = language ? language.substring(0, 2).toUpperCase() : null
      if (normalizedLanguage) {
        this.user.phonePrefix = this.prefixes.filter(
          prefix => prefix.code == normalizedLanguage,
        )[0].value
      }
    },
    showPasswordHandler() {
      this.passwordInputType = 'text'
    },
    hidePasswordHandler() {
      this.passwordInputType = 'password'
    },
  },
  validations() {
    if (this.submitted) {
      return {
        user: {
          email: {
            required,
          },
          password: {
            required,
            mbankPasswordComplexity: function (value) {
              if (this.$isMbank) {
                return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{0,}$/.test(
                  value,
                )
              } else {
                return true
              }
            },
            mbankPasswordLength: function (value) {
              if (this.$isMbank) {
                return value.length >= 12
              } else {
                return true
              }
            },
          },
          phonePrefix: {
            required,
          },
          phone: {
            required,
          },
          termsAgreement: {
            required,
            acceptance,
          },
          mbankPasswordAgreement: {
            mbankChecked: function (value) {
              if (this.$isMbank) {
                return value
              } else {
                return true
              }
            },
          },
        },
      }
    } else {
      return {}
    }
  },
  components: {
    Blocker: () => import('@/vcs/_shared/blocker/cmp.vue'),
  },
}
